<div>
  <app-header></app-header>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="card">
        <div class="card-body">
          <div class="card-title d-flex justify-content-center">
            <h1 class="titulo-principal">Al parecer ocurrió un problema</h1>
          </div>
          <div class="card-texto">
            <div class="row d-flex justify-content-center">
              <label class="subTitle widthText">Detectamos un error en la autorización del pago.</label>
            </div>
            <div class="row d-flex justify-content-center">
              <label class="text-center widthText">
                Tranquilo, <b>no se generado ningún cargo asociado a tu tarjeta</b>, para continuar con tu contratación,
                por favor prueba seleccionado <b>otro medio de pago</b> o <b>vuelve a intentarlo</b>
                <br>
                <b>en unos minutos más.</b>
              </label>
            </div>
            <div class="row d-flex justify-content-center">
              <button type="button" class="btn btn-primary" (click)="intentarNuevamente()">
                <div *ngIf="loadingButton" class="spinner-border text-light" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <span *ngIf="!loadingButton">Pagar Nuevamente</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="footer">
    <app-footer> </app-footer>
  </div>
</div>